import { render, staticRenderFns } from "./flashSaleProductOrder.vue?vue&type=template&id=74f63568"
import script from "./flashSaleProductOrder.vue?vue&type=script&lang=js"
export * from "./flashSaleProductOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports